import React from 'react';
import type { ReturnItem } from '../returnsTypes';
import styles from './ReturnItemRow.module.css';

interface ReturnItemRowProps {
  item: ReturnItem;
  onItemChange: (id: string, updates: Partial<ReturnItem>) => void;
}

export const ReturnItemRow: React.FC<ReturnItemRowProps> = ({ item, onItemChange }) => {
  return (
    <div className={styles.itemCard}>
      {/* Row 1 */}
      <div className={styles.row1}>
        <div className={styles.productInfo}>
          <span className={styles.productName}>{item.productName}</span>
          <span className={styles.sku}>SKU: {item.sku}</span>
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Quantity Returned</label>
          <input
            type="text"
            className={styles.input}
            value={item.quantityReturned}
            onChange={(e) => onItemChange(item.id, { quantityReturned: e.target.value })}
            placeholder=""
          />
        </div>
        <div className={styles.field}>
          <label className={styles.label}>Condition</label>
          <select
            className={styles.select}
            value={item.condition}
            onChange={(e) => onItemChange(item.id, { condition: e.target.value })}
          >
            <option value="">Select...</option>
            <option value="Good">Good</option>
            <option value="Damaged">Damaged</option>
            <option value="Defective">Defective</option>
            <option value="Opened">Opened</option>
          </select>
        </div>
      </div>

      {/* Row 2 */}
      <div className={styles.row2}>
        <label className={styles.checkboxLabel}>
          <input
            type="checkbox"
            className={styles.checkbox}
            checked={item.restockToInventory}
            onChange={(e) =>
              onItemChange(item.id, { restockToInventory: e.target.checked })
            }
          />
          <span className={styles.checkboxText}>Restock to inventory</span>
        </label>
        <div className={styles.notesField}>
          <label className={styles.label}>Notes</label>
          <input
            type="text"
            className={styles.input}
            value={item.notes}
            onChange={(e) => onItemChange(item.id, { notes: e.target.value })}
            placeholder=""
          />
        </div>
      </div>
    </div>
  );
};
